// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyAHLAu1Tyc9L5If_PoNL-Rc0afj69cg-ik",
    authDomain: "rodrigos-website.firebaseapp.com",
    databaseURL: "https://rodrigos-website.firebaseio.com",
    projectId: "rodrigos-website",
    storageBucket: "rodrigos-website.appspot.com",
    messagingSenderId: "527321291265"
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts